<template>
  <div class="h-auto self-start flex flex-col">
    <!-- Use the detailed article skeleton for magazine pages -->
    <MagazineArticleDetailSkeleton />
  </div>
</template>

<script setup lang="ts">
// Import the detailed skeleton component
import MagazineArticleDetailSkeleton from '~/components/magazine/article/MagazineArticleDetailSkeleton.vue'
</script>

<style lang="css" scoped>
@import '~/assets/css/loading.css';
</style>
